<core-versions-detail-preview-file
    *ngIf="status == STATUS_DONE"
    [version]="version"
    [file]="file"
    [menu]="menu"
    [context]="context"
    [canCreateNotes]="canCreateNotes"
    [notesUrlPrefix]="notesUrlPrefix"
    [annotationsUrlPrefix]="annotationsUrlPrefix"
    [annotationsSaveUrlPrefix]="annotationsSaveUrlPrefix"
    (menuClick)="onMenuClick($event)"
></core-versions-detail-preview-file>
